import { getElementTypesById } from "core-integration/src/store/element-types/reducers";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { pitchElementWrap } from "plos/src/components/ElementCard/ElementCard.css";
import { ValidCopnr } from "plos/src/utils/validCopnr";
import { useSelector } from "react-redux";
import { ElementProposedCard } from "../ElementProposedCard";
import { ElementSavedCard } from "../ElementSavedCard";
import { SquadPitchElementProps } from "./types";

const SquadPitchElement = ({
  actionMe,
  elementId,
  elementValue,
  isRemoved,
  renderElementMenu,
  pick,
}: SquadPitchElementProps) => {
  const elementTypesById = useSelector(getElementTypesById);
  const elementsById = useSelector(getElementsById);
  const nextEvent = useSelector(getNextEvent);
  const teamsById = useSelector(getTeamsById);

  const element = elementsById[elementId];
  if (!element) {
    return null;
  }

  const elementType = elementTypesById[element.element_type];
  const copnr = element.chance_of_playing_next_round as ValidCopnr;
  const team = teamsById[element.team];

  return (
    <div className={pitchElementWrap}>
      {isRemoved ? (
        <ElementSavedCard
          renderElementMenu={renderElementMenu}
          elementType={elementType}
          element={element}
          nextEvent={nextEvent}
          copnr={copnr}
          pick={pick}
        />
      ) : (
        <ElementProposedCard
          renderElementMenu={renderElementMenu}
          elementValue={elementValue}
          element={element}
          nextEvent={nextEvent}
          copnr={copnr}
          team={team}
          actionMe={actionMe}
          pick={pick}
        />
      )}
    </div>
  );
};

export default SquadPitchElement;
